import { useEffect, useMemo, useState } from 'react'

import { useRouter } from 'next/router'

import { DepositionsSection, Locale } from '@/service/api/landingPage'
import { useScreen } from '@/store/screen'
import { getLPTranslationData } from '@/utils/getLPTranslationData'

export const useDepositions = () => {
  const { windowSize } = useScreen()

  const router = useRouter()
  const locale = (router.locale || 'pt-BR') as Locale

  const [depositionsData, setDepositionsData] = useState<DepositionsSection>(
    () =>
      getLPTranslationData({
        landingPage: 'software',
        container: 'depositionsContainer',
        locale,
      }) as DepositionsSection,
  )

  useEffect(() => {
    const translationsObject = getLPTranslationData({
      landingPage: 'software',
      container: 'depositionsContainer',
      locale,
    }) as DepositionsSection

    setDepositionsData(translationsObject)
  }, [locale])

  const fontSizesByScreenSize = useMemo(() => {
    const fontsSizesByScreen = {
      1440: {
        title: 'h4' as const,
      },
      791: {
        title: 'h5' as const,
      },
    }
    return fontsSizesByScreen
  }, [])

  const { width } = windowSize
  const fontSizes = useMemo(() => {
    if (!width) return fontSizesByScreenSize[1440]
    if (width <= 791) return fontSizesByScreenSize[791]
    return fontSizesByScreenSize[1440]
  }, [width, fontSizesByScreenSize])

  return {
    fontSizes,
    depositionsData,
  }
}
